import { CloseIcon } from '@assets/icons/CloseIcon';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useNotification } from '../NotificationsHooks';

export type NotificationTheme = 'light' | 'dark';
export type NotificationType = 'success' | 'error' | 'warning';
export const GenericNotification = ({
  icon,
  title,
  description,
  testId,
  type,
  theme = 'dark',
}: {
  icon: React.JSX.Element;
  title: string;
  description: string;
  testId: string;
  type: NotificationType;
  theme?: NotificationTheme;
}) => {
  const { t } = useTranslation();
  const { close } = useNotification();

  return (
    <div
      data-testid={testId}
      className={classNames(`position: relative   rounded py-4 px-6 flex animate-fade`, {
        'shadow-[-3px_0px_0px_0px__#EB4B4B]': type === 'error',
        'shadow-[-3px_0px_0px_0px__#19A04B]': type === 'success',
        'shadow-[-3px_0px_0px_0px__#C17E19]': type === 'warning',
        'bg-sy-neutral-90': theme === 'dark',
        'bg-white': theme === 'light',
      })}
    >
      {icon}
      <div className="grid gap-2">
        <h4
          className={classNames('text-base font-semibold', {
            'text-sy-neutral-100': theme === 'light',
            'text-white': theme === 'dark',
          })}
        >
          {t(title)}
        </h4>
        <p
          className={classNames('max-w-[336px]', {
            'text-sy-neutral-100': theme === 'light',
            'text-white': theme === 'dark',
          })}
        >
          {t(description)}
        </p>
      </div>
      <button
        type="button"
        onClick={close}
        className="cursor-pointer h-5"
        data-testid={`${testId}-dismiss-button`}
      >
        <CloseIcon fill="#DFE2E7" />
      </button>
    </div>
  );
};
